export default __webpack_public_path__ + "static/media/placeholder_dummy2016-musikschule01-de.6aaea650.png";